import { call, put, select } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { CheckAvailabilitySuccessPayload, cleanup } from '../actions';
import { deleteFromBetSlip, InsertInQueueForDelete } from '../actions/entries';
import { selectBets, selectDeletesQueue } from '../selectors/entries';
import { EntriesBets } from '../types/entries';
import checkAvailability from './checkAvailability';

// ---

export default function* removeEntriesFlow(payload: InsertInQueueForDelete['payload']): SagaIterator {
  const queue = yield select(selectDeletesQueue);
  const entries: EntriesBets = yield select(selectBets);

  for (let i = 0; i < payload.entries.length; i++) {
    const entryId = payload.entries[i].betId;

    if (!queue.has(entryId)) { // this actually shouldn't happen
      throw new Error(`removeEntriesFlow -> the deletion of #${entryId} is not queued`);
    }

    if (!entries.has(entryId)) { // this actually shouldn't happen
      throw new Error(`removeEntriesFlow -> there's no bet slip entry #${entryId}`);
    }
  }

  if (entries.size === payload.entries.length) { // we have the last entries in the payload.
    yield put(cleanup()); // dispatching the `cleanup()` action,
    return; // exiting the "remove entries" flow,
    // ... preventing stake types availability and match recalculation request flows.
  }

  // -- requesting stake types availability -- //

  let availabilityResult: CheckAvailabilitySuccessPayload;

  const nextEntries = payload.entries.reduce((entries, entry) => {
    return entries.delete(entry.betId); // excluding the removing bet entries
  }, entries);

  try {
    availabilityResult = yield call(checkAvailability, nextEntries);
  }
  catch (err) {
    yield put(deleteFromBetSlip(payload));
    return;
  }

  const {
    singles,
    express,
    systems,
    availableStakeTypes,
  } = availabilityResult;

  // no conflicts or resolved w/o cancelling

  yield put(deleteFromBetSlip({
    ...payload,
    singles,
    express,
    systems,
    availableStakeTypes,
  }));
}
